export const isDirectoryEmail = (value) => value.length <= 250 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
